import { Marker, InfoBox } from "@react-google-maps/api";
import "./style.scss";
import { useState } from "react";
import { HasLatLong, VehicleStopResponse } from "types/trip.types";
import { ColorSpectrum } from "types/ColorSpectrum";
interface UnknownPlaceMarkerProps {
  place: HasLatLong;
  stopIndex: number;
  color?: ColorSpectrum;
  highlight?: boolean;
  label?: string;
  displayComputed?: boolean;
  tripId?: number;
  tooltip?: any;
  /* eslint-disable */
  onHover?: (stopId: number, isOver: boolean) => void;
  onAction?: (action: string, params?: any) => void;
  /* eslint-enable */
}
export default function UnknownPlaceMarker({
  place,
  stopIndex,
  color,
  highlight,
  label,
  tooltip,
  tripId,
  onAction,
  displayComputed,
}: UnknownPlaceMarkerProps) {
  const stopCompleted = true;
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(!clicked);
    onAction && onAction("map-place-click", { point: place, tripId });
  };
  return (
    <>
      <Marker
        position={{ lat: place.latitude, lng: place.longitude }}
        // onMouseOver={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, true);
        // }}
        // onMouseOut={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, false);
        // }}
        icon={{
          path: "M -5,0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0",
          strokeColor: color?.dark40,
          strokeWeight: 8,
          fillOpacity: 0.5,
        }}
      />
      <Marker
        position={{ lat: place.latitude, lng: place.longitude }}
        // onMouseOver={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, true);
        // }}
        // onMouseOut={() => {
        //   onHover && onHover(stop.tripStopId ?? 0, false);
        // }}
        zIndex={highlight ? 99999 : undefined}
        icon={
          highlight
            ? {
                path: "M -4,0 a 4,4 0 1,0 8,0 a 4,4 0 1,0 -8,0",
                fillColor: color?.dark40,
                strokeColor: color?.dark40,
                strokeWeight: 30,
                fillOpacity: 0.5,
              }
            : {
                path: "M -5,0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0",
                fillColor: stopCompleted
                  ? color?.main ?? "red"
                  : color?.light20,
                strokeColor: color?.main ?? "red",
                strokeWeight: 4,
                fillOpacity: 1,
              }
        }
        label={{
          text: label ?? (stopIndex > 0 ? `${stopIndex}` : "W"),
          fontSize: "16pt",
          fontWeight: "bold",
          color: highlight ? color?.light20 : color?.dark40,
        }}
        title={tooltip}
        onClick={handleClick}
      >
        {highlight && (
          <InfoBox onCloseClick={() => {}}>
            <div className="map-stop-info"></div>
          </InfoBox>
        )}
      </Marker>
    </>
  );
}
